import { config } from './config.js';
import { AbstractApi } from './abstract-api.js';

interface BrandCountResponse {
  count: number;
}

export interface BrandApi {
  addBrand(brandCode: string): Promise<number | null>;
  removeBrand(brandCode: string): Promise<number | null>;
  containsBrands(brandCodes: string[]): Promise<string[]>;
  mergeBrands(): Promise<boolean>;
}

class BrandApiClass extends AbstractApi implements BrandApi {
  async addBrand(brandCode: string): Promise<number | null> {
    try {
      const result = await this.postJson<BrandCountResponse>(`${config.apiEndpoint}brand`, 'Brand', { brandCode });
      return result.count;
    } catch (e) {
      console.error(e);
      return null;
    }
  }

  async removeBrand(brandCode: string): Promise<number | null> {
    try {
      const result = await this.deleteJson<BrandCountResponse>(`${config.apiEndpoint}brand`, 'Brand', { brandCode });
      return result.count;
    } catch (e) {
      console.error(e);
      return null;
    }
  }

  async containsBrands(brandCodes: string[]): Promise<string[]> {
    try {
      return await this.postJson<string[]>(`${config.apiEndpoint}brand/contains`, 'Brand', brandCodes);
    } catch (e) {
      console.error(e);
      return [];
    }
  }

  async mergeBrands(): Promise<boolean> {
    return this.post(`${config.apiEndpoint}brand/merge`, 'Brand', {});
  }
}

export const BrandApiInstance: BrandApi = new BrandApiClass();
